import { NgModule, CUSTOM_ELEMENTS_SCHEMA, LOCALE_ID } from '@angular/core';
import { registerLocaleData } from '@angular/common';
import localeDk from '@angular/common/locales/da';
import { AppRoutingModule } from '@app/app.routing';
import { AppComponent } from './root/app.component';
import { services } from './app.services';
import { imports as mainImports } from './app.imports';
import { environment } from 'environments/environment';
import {
  GrowthBookModule,
  GrowthBookService,
} from './shared/modules/growthbook';
import { provideClarity } from 'ngx-clarity';
import { LottieModule } from 'ngx-lottie';
import { MatNativeDateModule } from '@angular/material/core';
import { AIService } from '@services/http/ai.service';

registerLocaleData(localeDk);

export function playerFactory() {
  return import('lottie-web');
}

const imports = [
  GrowthBookModule.forRoot(),
  AppRoutingModule,
  MatNativeDateModule,
  mainImports,
  LottieModule.forRoot({ player: playerFactory }),
];

@NgModule({
  imports,
  declarations: [],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  providers: [
    GrowthBookService,
    services,
    { provide: LOCALE_ID, useValue: 'da-DK' },
    provideClarity({
      enabled: environment.production && environment.env === 'production',
      projectId: 'jchi9d10c0',
    }),
    AIService,
  ],
  bootstrap: [AppComponent],
  exports: [],
})
export class AppModule {}
